<template>
  <vxe-grid
    ref="table"
    highlight-hover-row
    :toolbar-config="tableToolbar"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="tableHeight"
    size="small"
    resizable
    border
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
    }"
    row-id="orderCode"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <b-button-group>
          <el-tooltip
            class="item"
            effect="dark"
            content="称重登记"
            placement="top"
          >
            <i
              class="el-icon-collection tool-btn"
              @click="weigh(row.waybillCode)"
            ></i>
          </el-tooltip>
        </b-button-group>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    weigh(code) {
      this.$router.push({
        name: 'carrier-weight-weightRecord-detail-page',
        params: { code },
      })
    },
  },
}
</script>
